export const trimInputs = (inputs: Record<string, string | undefined | null>) =>
	Object.fromEntries(Object.entries(inputs).map(([key, value]) => [key, value?.trim() || '']));
